import React, { useEffect, useRef, useState } from 'react';
import * as Tone from 'tone';

function App() {
  const synth = useRef();
  const [nowPlaying, setNowPlaying] = useState('');

  useEffect(() => {
    synth.current = new Tone.PolySynth(Tone.Synth).toDestination();
  }, []);

  const chords = [
    { name: 'Cmaj7', notes: ['C4', 'E4', 'G4', 'B4'], color: '#00ffff' },
    { name: 'Fmaj7', notes: ['F4', 'A4', 'C5', 'E5'], color: '#ff00ff' },
    { name: 'G7', notes: ['G4', 'B4', 'D5', 'F5'], color: '#ffff00' },
    { name: 'Am7', notes: ['A4', 'C5', 'E5', 'G5'], color: '#00ff00' },
    { name: 'Dm7', notes: ['D4', 'F4', 'A4', 'C5'], color: '#ff8800' },
    { name: 'E7', notes: ['E4', 'G#4', 'B4', 'D5'], color: '#ff0088' },
    { name: 'A7', notes: ['A4', 'C#5', 'E5', 'G5'], color: '#8800ff' },
    { name: 'Bb7', notes: ['Bb4', 'D5', 'F5', 'Ab5'], color: '#0088ff' },
    { name: 'Ebmaj7', notes: ['Eb4', 'G4', 'Bb4', 'D5'], color: '#ff0000' },
    { name: 'Abmaj7', notes: ['Ab4', 'C5', 'Eb5', 'G5'], color: '#00ff88' },
    { name: 'Dbmaj7', notes: ['Db4', 'F4', 'Ab4', 'C5'], color: '#ff88ff' },
    { name: 'Gbmaj7', notes: ['Gb4', 'Bb4', 'Db5', 'F5'], color: '#88ff00' },
  ];

  const playChord = (chord) => {
    if (synth.current) {
      synth.current.releaseAll();
      synth.current.triggerAttackRelease(chord.notes, '1s');
      setNowPlaying(chord.name);
      setTimeout(() => {
        setNowPlaying('');
      }, 1000);
    }
  };

  return (
    <div className="App">
      <h1>Launchpad</h1>
      <div className="chord-grid">
        {chords.map((chord) => (
          <div
            key={chord.name}
            className={`chord ${nowPlaying === chord.name ? 'chord-active' : ''}`}
            onClick={() => playChord(chord)}
            style={{ '--glow-color': chord.color }}
          >
            {chord.name}
          </div>
        ))}
      </div>
    </div>
  );
}

export default App;
